import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'telefone',
})
export class TelefonePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value

    value = value.replace(/\D/g, '') // Remove tudo o que não for número
    if (value.length <= 10) {
      return value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3') // Formato (XX) XXXX-XXXX
    } else if (value.length === 11) {
      return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') // Formato (XX) XXXXX-XXXX
    }
    return value
  }
}
